import React from "react";
import Icon1 from "../../icons/Icon";
import { useState, useEffect } from "react";
const LoomEmbed = ({
  id = "6c8b6b0343b84c2da1ad76413faf23c6?sid=4e8f4f4e-6b6d-42ca-9dc2-a844956ff4e9",
}) => {
  const [fullscreen, setFullscreen] = useState(false);
  const goFullScreen = () => {
    setFullscreen(!fullscreen);
  };

  // listen to Esc key
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) {
        setFullscreen(false);
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, []);
  const [hovering, setHovering] = useState(false);
  return (
    <div
      className={`  h-0 ${fullscreen ? "fixed  inset-0 z-50 w-screen h-screen  border-blue-500 border-3" : "relative"}`}
      style={{
        paddingTop: fullscreen ? "0%" : "56.25%",
      }}
    >
      <iframe
        src={`https://www.loom.com/embed/${id}&hideEmbedTopBar=true`}
        frameBorder="0"
        allowFullScreen
        className={`absolute inset-0 w-full h-full top-0 left-0 bg-shadow_10  ${fullscreen ? "border-3 border-blue-500" : "rounded-xl"}`}
      ></iframe>
    </div>
  );
};

export default LoomEmbed;
